// Módulo liviano a propósito: lo importa el tile del Panel (`KpiStrip`) y no tiene que arrastrar la
// pantalla entera para armar un link.

export function clientAlertsPath(clientId) {
    return `/client/${clientId}/alerts`;
}

// Fecha LOCAL YYYY-MM-DD de hace N días (`toISOString()` la pasaría a UTC, y en Argentina eso corre
// el día uno para atrás).
function localDateDaysAgo(daysAgo) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * La Bitácora filtrada en las alertas de la ventana de vigencia: el HISTORIAL, una fila por cada vez
 * que sonó (más filas que problemas vigentes). Era el destino del tile hasta la card j61xJLod; hoy
 * es el pie de la pantalla de Alertas y el destino sin la ficha 2.1.
 */
export function bitacoraAlertsPath(clientId, windowDays = 7) {
    return `/client/${clientId}/memory/bitacora?layers=alerts`
        + `&date_from=${localDateDaysAgo(windowDays - 1)}`;
}
